import Navigation from "@/components/Navigation";
import OrderCostTab from "@/components/OrderCostTab";

export default function OrderCostPage() {
  return (
    <div className="min-h-screen bg-background" data-testid="order-cost-page">
      <Navigation />
      <div className="container mx-auto px-4 py-6 max-w-7xl">
        <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight mb-6">Orderkostnad</h1>
        <OrderCostTab />
      </div>
    </div>
  );
}
